import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { AnimationSpeed } from '../../../models/enums/animation-speed.enum';
import { HttpService } from '../../../services/http.service';
import { ISubscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-arrows',
    templateUrl: './arrows.component.html',
    styleUrls: ['./arrows.component.scss']
})
export class ArrowsComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() titleTop: boolean = true;
    @Input() directionRight: boolean = true;
    @Input() animationSpeed: AnimationSpeed = AnimationSpeed.normal;
    @Input() speedUnit: string;
    @Input() speed: number;

    @Input() systemId: string;
    @Input() subSystemId: string = null;
    
    animationSpeeds = AnimationSpeed;

    subscription: ISubscription;

    constructor(private http: HttpService, private cdref: ChangeDetectorRef) { }

    ngOnInit() {
        this.http.dashboardData().subscribe(data => {
            let filtered = data.filter(sys => sys.systemId == this.systemId && sys.subSystemId == this.subSystemId);
            if (filtered.length > 0) {
                this.speed = filtered[0].value;
                this.cdref.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/stats/arrows/arrows.component.ts